import { html, TemplateResult } from 'lit-html';
import '../src/nile-button/nile-button';
import '../src/nile-spinner/nile-spinner';
import '../src/nile-icon';

export default {
  title: 'Components/NileButton',
  component: 'nile-button',
  argTypes: {
    variant: { control: 'select', options: ['primary', 'secondary', 'tertiary', 'caution'], action: 'variantChange' },
    size: { control: 'select', options: ['small', 'medium', 'large'], action: 'sizeChange' },
    caret: { control: 'boolean', action: 'caretChange' },
    disabled: { control: 'boolean', action: 'disabledChange' },
    loading: { control: 'boolean', action: 'loadingChange' },
    outline: { control: 'boolean', action: 'outlineChange' },
    pill: { control: 'boolean', action: 'pillChange' },
    circle: { control: 'boolean', action: 'circleChange' },
    type: { control: 'select', options: ['button', 'submit', 'reset'], action: 'typeChange' },
  },
};

interface StoryArgs {
  variant: 'primary' | 'secondary' | 'tertiary' | 'caution';
  size: 'small' | 'medium' | 'large';
  caret: boolean;
  disabled: boolean;
  loading: boolean;
  outline: boolean;
  pill: boolean;
  circle: boolean;
  type: 'button' | 'submit' | 'reset';
}

interface Story {
  (args: StoryArgs): TemplateResult;
  args?: Partial<StoryArgs>;
}

const Template: Story = (args: StoryArgs): TemplateResult => {
  return html`
    <nile-button
      variant="${args.variant}"
      size="${args.size}"
      ?caret="${args.caret}"
      ?disabled="${args.disabled}"
      ?loading="${args.loading}"
      ?outline="${args.outline}"
      ?pill="${args.pill}"
      ?circle="${args.circle}"
      type="${args.type}"
    >
      Button
    </nile-button>
  `;
};

export const Default = Template.bind({});
Default.args = {
  variant: 'primary',
  size: 'medium',
  caret: false,
  disabled: false,
  loading: false,
  outline: false,
  pill: false,
  circle: false,
  type: 'button',
};

export const PrimaryLargeButton = Template.bind({});
PrimaryLargeButton.args = {
  ...Default.args,
  variant: 'primary',
  size: 'large',
};

export const SecondarySmallButton = Template.bind({});
SecondarySmallButton.args = {
  ...Default.args,
  variant: 'secondary',
  size: 'small',
};

export const TertiaryDisabledButton = Template.bind({});
TertiaryDisabledButton.args = {
  ...Default.args,
  variant: 'tertiary',
  disabled: true,
};

export const CautionLoadingButton = Template.bind({});
CautionLoadingButton.args = {
  ...Default.args,
  variant: 'caution',
  loading: true,
};
